module.exports = __webpack_public_path__ + "static/media/not_found.27b78f10.svg";